import React from 'react';
import Reveal from './Reveal';

const SectionHeading = ({ eyebrow, title, subtitle, id, align = 'center', tone = 'dark' }) => {
  const isCenter = align === 'center';
  const titleColor = tone === 'light' ? 'text-white' : 'text-primary';
  const subColor = tone === 'light' ? 'text-white/70' : 'text-accent';

  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-3xl' : 'max-w-2xl'} mb-9 sm:mb-12 md:mb-16`}>
      {eyebrow && (
        <Reveal>
          <span className="eyebrow">
            <span className="h-px w-6 bg-secondary" aria-hidden="true" />
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 id={id} className={`mt-4 text-3xl sm:text-4xl md:text-5xl font-bold ${titleColor}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`mt-5 text-base md:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeading;
